import { LandlineTypeIcon, MobileTypeIcon } from 'assets/icons'

import * as Styled from './styled'
import { useState } from 'react'
import { useAuth } from 'components/providers/AuthProvider'
import { PhoneType } from './LoginPage'
import PhoneTypePopup from './PhoneTypePopup'

export interface PhoneTypePickerProps {}

export default function PhoneTypePicker(props: PhoneTypePickerProps) {
  const auth = useAuth()
  const [showPicker, onShowPicker] = useState(false)
  const togglePhonePicker = () => {
    onShowPicker(!showPicker)
  }
  return (
    <PhoneTypePopup setOpen={onShowPicker} open={showPicker}>
      <div style={{ height: '48px' }}>
        <Styled.PhoneTypePicker
          selected={showPicker}
          onClick={auth.phoneTypeUpdateFlow ? undefined : togglePhonePicker}
        >
          {auth.phoneType === PhoneType.Mobile || auth.phoneTypeUpdateFlow ? (
            <MobileTypeIcon style={{ marginLeft: 8 }} width={16} />
          ) : (
            <LandlineTypeIcon width={16} />
          )}
        </Styled.PhoneTypePicker>
      </div>
    </PhoneTypePopup>
  )
}
